import { render, staticRenderFns } from "./discount-rate-product-list.vue?vue&type=template&id=6126eb86&scoped=true&"
import script from "./discount-rate-product-list.vue?vue&type=script&lang=js&"
export * from "./discount-rate-product-list.vue?vue&type=script&lang=js&"
import style0 from "./discount-rate-product-list.vue?vue&type=style&index=0&id=6126eb86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6126eb86",
  null
  
)

export default component.exports